import { createActions, createReducer } from 'reduxsauce'

import ConsultaPrestacaoContasAnualService from '../../servicos/ConsultaPrestacaoContasAnualService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPrestacaoContasAnualInicio: [],
    buscaConsultaPrestacaoContasAnualErro: ['erro'],
    buscaConsultaPrestacaoContasAnualSucesso: ['consultaPrestacaoContasAnual'],
    limpar: [],
    setConsultaPrestacaoContasAnualEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPrestacaoContasAnual = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPrestacaoContasAnualInicio())
        let serv = new ConsultaPrestacaoContasAnualService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaPrestacaoContasAnualSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPrestacaoContasAnualErro(error)))
    }
}

const buscaConsultaPrestacaoContasAnualInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPrestacaoContasAnualErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaPrestacaoContasAnualSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPrestacaoContasAnual.resultado,
        dataSincronizacaoDados: action.consultaPrestacaoContasAnual.dataSincronizacaoDados,
        fonte: action.consultaPrestacaoContasAnual.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPrestacaoContasAnualEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PRESTACAO_CONTAS_ANUAL_INICIO]: buscaConsultaPrestacaoContasAnualInicio,
    [Types.BUSCA_CONSULTA_PRESTACAO_CONTAS_ANUAL_ERRO]: buscaConsultaPrestacaoContasAnualErro,
    [Types.BUSCA_CONSULTA_PRESTACAO_CONTAS_ANUAL_SUCESSO]: buscaConsultaPrestacaoContasAnualSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PRESTACAO_CONTAS_ANUAL_ESTADO_DT]: setConsultaPrestacaoContasAnualEstadoDT,
})
